module.exports = __webpack_public_path__ + "img/office.b16ac528.svg";